export const gameTypes = [
  {
    id: 'classification',
    label: 'Account Classification',
    description: 'In this exercise, accounts are falling and you have to classify them quickly and accurately to build mastery.'
  },
  {
    id: 'normal',
    label: 'Normal Balances/T-Accounts',
    description: 'In this exercise, you have to sort accounts to their correct normal balances.'
  },
  {
    id: 'equation',
    label: 'Accounting Equation',
    description: 'In this exercise, you\'ll review transactions and determine their impact on the accounting equation. The decisions may include increases/decreases, debits and credits, specific accounts, and/or income statement impact.'
  },
  {
    id: 'principles',
    label: 'Principles, Assumptions, Constraints',
    description: 'In this exercise, you\'ll analyze a series of activities and identify which principles, assumptions, and constraints apply to each.'
  }
];

export const gameTypesReviewSession = [
  {
    id: 'classification',
    label: 'Account Classification (<span>5mins exercise</span>)',
    minutes: 5
  },
  {
    id: 'normal',
    label: 'Normal Balances/T-Accounts (<span>5mins exercise</span>)',
    minutes: 5
  },
  {
    id: 'equation',
    label: 'Accounting Equation (<span>10mins exercise</span>)',
    minutes: 10
  },
  {
    id: 'principles',
    label: 'Principles, Assumptions, Constraints (<span>10mins exercise</span>)',
    minutes: 10
  }
];

export const businessTypes = [
  {
    id: 'corporate',
    label: 'Corporations',
    description: '(e.g. Common Stock and Retained Earnings)'
  },
  {
    id: 'noncorporate',
    label: 'Non-Corporations',
    description: '(e.g. Owner’s Capital and Owner’s Drawing)'
  }
];

export const nonCorporateTypes = [
  {
    id: 'noncorporate-services',
    label: 'Services'
  },
  {
    id: 'noncorporate-merchandising',
    label: 'Merchandising'
  }
];

export const scenarioLevelsDescription = {
  'classification': [
    'The Elements of the Financial Statements: At this level, the 5 Elements of financial statements will fall one by one.: You have to sort each falling Element to the correct financial statement.',
    'The Accounts of the Financial Statements: At this level, several Accounts of financial statements will fall one by one.: You have to sort each falling Account to the correct Elements of the financial statement.'
  ],
  'normal': [
    'The Elements of the Financial Statements: At this level, the 5 Elements of financial statements will fall one by one.: You have to sort each falling Element to its correct Normal Balance.',
    'The Accounts of the Financial Statements: At this level, several Accounts of financial statements will fall one by one.: You have to sort each falling Account to its correct Normal Balance.',
  ],
  'equation': [
    'Elements Impacted: At this level, you are going to review a series of transactions and have to decide how each transaction impacts the Balance Sheet Elements.: In Level I, you have to decide if the transaction increases or decreases Assets, Liabilities, and Equity.',
    'Accounts Impacted: In Level 2, you\'ll need to make an additional decision. You’ll need to determine which accounts will be impacted by each transaction.',
    'Debits & Credits: In this level, you\'ll need to make a third decision. You’ll need to determine which account should be debited and credited for each transaction.'
  ],
  'principles': [
    'Elements Impacted: At this level, you are going to review a series of transactions and have to decide how each transaction impacts the Balance Sheet Elements.: In Level I, you have to decide if the transaction increases or decreases Assets, Liabilities, and Equity.',
    'Accounts Impacted: In Level 2, you\'ll need to make an additional decision. You’ll need to determine which accounts will be impacted by each transaction.',
    'Debits & Credits: In this level, you\'ll need to make a third decision. You’ll need to determine which account should be debited and credited for each transaction.'
  ]
}

export const gameCreateItemsQuestionsColumns = [
  'Assets',
  'Liabilities',
  'Equity',
  'Revenues',
  'Expenses'
];

export const gameCreateItemsOptionsClassification = [
  'Balance Sheet',
  'Income Statement'
];

export const gameCreateItemsOptionsNormal = [
  'Debit',
  'Credit'
];

export const roundNames = {
  1: ['Championship'],
  2: ['Final Four', 'Championship'],
  3: ['Elite 8', 'Final Four', 'Championship'],
  4: ['Sweet 16', 'Elite 8', 'Final Four', 'Championship'],
};

export const teamNames = [
  'RevReco',
  'The Elements',
  'Expense It',
  'Accrue It',
  'Debit Divas',
  'The Normals',
  'Accruelife',
  'LedgerSquad',
  'JournalUp',
  'Post&Pray',
  'Depreciate It',
  'FIFOFighters',
  'Adjust It',
  'The Source',
  'EarnSome',
  'LIFOLegends'
];